<template>
    <v-dialog
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
      max-width="900px"
    >
      <v-card>
        <v-card-title>Client URL Generated</v-card-title>
        <v-card-text>
          <p class="mb-4">Share this URL with your client:</p>
          <v-text-field
            :model-value="generatedUrl"
            readonly
            variant="outlined"
            append-inner-icon="mdi-content-copy"
            @click:append-inner="copyUrl"
          ></v-text-field>
          <v-alert
            v-if="showCopiedAlert"
            color="success"
            variant="tonal"
            class="mt-2"
          >
            URL copied to clipboard!
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="text"
            @click="$emit('update:modelValue', false)"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script setup lang="ts">
  import { computed, ref } from 'vue';
  
  interface Props {
    modelValue: boolean;
    clientId: string;
  }
  
  const props = defineProps<Props>();
  const emit = defineEmits<{
    'update:modelValue': [value: boolean];
  }>();
  
  const showCopiedAlert = ref(false);
  
  const generatedUrl = computed(() => {
    const baseUrl = process.env.VUE_APP_LANDING_PAGE_URL;
    console.log(baseUrl);
    return `${baseUrl}${props.clientId}`;
  });
  
  const copyUrl = async () => {
    try {
      await navigator.clipboard.writeText(generatedUrl.value);
      showCopiedAlert.value = true;
      setTimeout(() => {
        showCopiedAlert.value = false;
      }, 2000);
    } catch (err) {
      console.error('Failed to copy URL:', err);
    }
  };
  </script>